import React from 'react';

type Props = {
    condition: boolean;
    children: React.ReactNode | (() => React.ReactNode);
};

export const RenderIf = ({ condition, children }: Props) => {
    if (!condition) return null;

    return <>{typeof children === 'function' ? children() : children}</>;
};
